// extracted by mini-css-extract-plugin
export default {"wrapper":"PercentSectionCard_wrapper__Xhu9U","title":"PercentSectionCard_title__4XE+s","percent":"PercentSectionCard_percent__zv1ht"};